import { render, staticRenderFns } from "./WorkingoutExerciseGuide.vue?vue&type=template&id=1d9674d8&scoped=true"
import script from "./WorkingoutExerciseGuide.vue?vue&type=script&lang=js"
export * from "./WorkingoutExerciseGuide.vue?vue&type=script&lang=js"
import style0 from "./WorkingoutExerciseGuide.vue?vue&type=style&index=0&id=1d9674d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9674d8",
  null
  
)

export default component.exports